import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import React from "react";

import { RouteName } from "@/consts/RouteName";
import { postDetailPageTranslations } from "@/consts/pageTranslationNamespace";
import { Container } from "@/features/common/components/layout/Container";
import { InfiniteMasonry } from "@/features/post/components/InfiniteMasonry";
import { getPublicConfig } from "@/helpers/getPublicConfig";
import { getServerSidePropswithApollo } from "@/server/graphql/apollo";

const config = getPublicConfig();

/* Related to fetchMore logic */
export default function TagPage() {
  const { t } = useTranslation("post");
  const { query, push } = useRouter();

  if (typeof query.tag !== "string") {
    return push(RouteName.Home);
  }

  return (
    <>
      <NextSeo
        title={`Tag ${query.tag} | ${config.siteName}`}
        canonical={config.domain + "/home"}
      />

      <Container className="py-4">
        <h1 className="px-4 text-2xl text-gray-900">{`${query.tag} 類別貼文`}</h1>

        <InfiniteMasonry
          postPageVariables={{ input: { tagValue: query.tag } }}
        />
      </Container>
    </>
  );
}

export const getServerSideProps = getServerSidePropswithApollo(
  async ({ params, locale }) => {
    // const slug = convertWhitespaceToPlusInSlug(params?.slug as string);
    const translationProps = await serverSideTranslations(
      locale,
      postDetailPageTranslations,
    );

    return {
      props: { ...translationProps },
    };
  },
);
